
const getMod = (score) => {
    return Math.floor((score - 10) / 2) || 0;
}

const calcPassive = (creature, cKey, passiveLabel) => {
    if(!creature[cKey]) return 0

    // creature['wisdom']
    let value = 10 + getMod(creature[cKey])
    let profBonusType = creature.proficiencies?.[passiveLabel];
    if(profBonusType) {
        // proficiency or expertise on a passive check is +prof_bonus or +prof_bonus*2 respectively
        value += profBonusType === 'expertise' 
            ? creature.prof_bonus * 2 
            : creature.prof_bonus
    } else if(creature.proficiencies?.['ability-checks'] === "half-proficiency") {
        // i.e. jack of all trades gives passives a half proficiency bonus while other proficiencies are not applied
        value += Math.floor(creature.prof_bonus / 2)
    }

    let advantageBonusType = creature.advantages?.[passiveLabel];

    if(advantageBonusType) {
        // advantage or disadvantage on a passive check is +5 or -5 respectively
        value += advantageBonusType === 'advantage' ? 5 : -5
    }
    
    return value
}

const EncounterListItemSmallStat = ({label, creature, quickEdit, onChange, showLabel=true}) => {

    const handleHighlight = (e) => {
        e.target.select();
    };
    // Passive Perception, Passive Investigation, Passive Insight and Spell Save DC

    let showLabelStyle = showLabel
        ? {padding: "1px 2px", margin: '2px 2px 2px 0px'}
        : {padding: "0px 0px", margin: '0px 0px 0px 0px', fontSize: '.8em', fontWeight: 'bold', width: '18px', borderRadius: '3px', color: "#00232e"};

    let title = showLabel ? "AC" : "Passive Perception | Passive Investigation | Passive Insight | Spell Save DC"

    let value = ''
    if(label === "AC") {
        value = creature.armor_class
    } else if (label === "Perception") {
        // Passives = 10 plus modifiers that apply i.e. 10 + Wisdom Mod
        value = calcPassive(creature, 'wisdom', 'perception')
    } else if (label === "Insight") {
        value = calcPassive(creature, 'wisdom', 'insight')
    } else if (label === "Investigation") {
        value = calcPassive(creature, 'intelligence', 'investigation')
    } else if (label === "Spell Save DC") {
        let spellMod = 0;
        let c = creature.classes || ""
        // Spellcasting Ability Modifier:
        //   Intelligence: Wizards, Artificers
        //   Wisdom:       Clerics, Druids, Rangers
        //   Charisma:     Bards, Sorcerers, Warlocks, Paladins
        if(c.includes("Wizard") || c.includes("Artificer")) {
            spellMod = getMod(creature.intelligence)
        } else if(c.includes("Cleric") || c.includes("Druid") || c.includes("Ranger")) {
            spellMod = getMod(creature.wisdom)
        } else if(c.includes("Bard") || c.includes("Sorcerer") || c.includes("Warlock") || c.includes("Paladin")) {
            spellMod = getMod(creature.charisma)
        } else { // If none of these are found check for custom spellcasting ability i.e Fight gets Eldritch Knight
            if(creature?.spellcasting[0]?.headerEntries) {
                // Extract the spellcasting ability from the header entries if available
                let skill = creature.spellcasting[0].headerEntries.match(/^\w+/)?.[0]
                spellMod = getMod(creature[skill?.toLowerCase()])
            }
        }

        // 8 + Proficiency Bonus + that class's specific Spellcasting Ability Modifier
        value = 8 + (creature.prof_bonus || 0) + spellMod
        showLabelStyle = {...showLabelStyle, color: "#006b8b", marginLeft: "4px"}
    }


    return (
        <>
            {showLabel &&
                <label htmlFor='ac' className='editAcLabel' style={{borderBottom: `2px ${quickEdit ? "dotted" : "solid"} #919191`}}>{label}</label>
            }
            {quickEdit ? 
                <>
                    <input id='ac' className='middleStatsInput' title={title} style={{borderBottom: '2px dotted #919191', ...showLabelStyle}} onFocus={handleHighlight} type='numeric' value={value} onChange={onChange} onBlur={(e) => onChange(e, true)} onClick={(event) => {event.stopPropagation()}}/>
                    {creature.dnd_b_player_id && 
                        <span className='editAcLabel' title='Dnd Beyond Player Id' style={{cursor: 'auto', padding: '1px 2px 1px 1px', borderRight: 'solid 1px #919191', borderRadius: '2px'}}>
                            <i>{creature.dnd_b_player_id[0] === '!' ? creature.dnd_b_player_id.slice(1) : creature.dnd_b_player_id}</i>
                        </span>
                    }
                </>
            : 
                <div className='middleStatsInput' title={title} style={showLabelStyle}> {value.toString().split(" ")[0]} </div>
            }
        </>
  );
}

export default EncounterListItemSmallStat;